// src/components/ExportPDFButton.js
import React from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const generatePDF = ({ data, filename = "export.pdf", headers = [], chartImages = [] }) => {
  const doc = new jsPDF();
  let y = 15;

  doc.setFontSize(16);
  doc.text("Reporte", 14, y);
  y += 10;

  chartImages.forEach((img) => {
    if (img) {
      if (y >= 250) {
        doc.addPage();
        y = 20;
      }
      doc.addImage(img, "PNG", 15, y, 180, 80);
      y += 90;
    }
  });

  const secciones = {};
  let seccionActual = "Sin sección";

  data.forEach((row) => {
    const tieneValores = Object.values(row).some((val) => val && val.toString().trim() !== "");
    if (row.seccion) {
      seccionActual = row.seccion;
      if (!secciones[seccionActual]) secciones[seccionActual] = [];
    }
    if (!secciones[seccionActual]) secciones[seccionActual] = [];
    if (tieneValores) {
      secciones[seccionActual].push(row);
    }
  });

  Object.entries(secciones).forEach(([titulo, rows]) => {
    const visibleKeys = headers.map((h) => h.key);
    const visibleLabels = headers.map((h) => h.label);
    const body = rows.map((row) =>
      visibleKeys.map((key) => (row[key] != null ? String(row[key]) : ""))
    );

    if (body.length === 0) return;
    if (y >= 250) {
      doc.addPage();
      y = 20;
    }

    doc.setFontSize(14);
    doc.text(String(titulo), 14, y);
    y += 5;

    autoTable(doc, {
      startY: y,
      head: [visibleLabels],
      body,
      styles: { fontSize: 9 },
      theme: "striped",
      margin: { left: 14, right: 14 },
    });

    y = doc.lastAutoTable.finalY + 10;
  });

  doc.save(filename);
};


const ExportPDFButton = ({ data, filename, headers, chartImages = [] }) => {
  return (
    <button
      onClick={() => generatePDF({ data, filename, headers, chartImages })}
      className="btn-primary"
      style={{ marginLeft: 10 }}
    >
      Exportar PDF
    </button>
  );
};

export default ExportPDFButton;